<template>
  <v-container>
    <v-breadcrumbs
      class="px-0 py-2"
      :items="breadcrumbs"
    />
    <h2>
      産廃回収の編集
    </h2>
    <order-form :edit-order-id="editOrderId" />
  </v-container>
</template>

<script>
import OrderForm from './_Form'
export default {
  name: 'DriverOrderAcceptCollectionEdit',
  components: {
    OrderForm,
  },
  mixins: [],
  props: {},
  data() {
    return {
      breadcrumbs: [],
      editOrderId: null,
    }
  },
  computed: {},
  watch: {},
  created() {

    this.editOrderId = parseInt(this.$route.params.id);

    this.breadcrumbs = []
    if (this.$route.query.d !== undefined) {
      this.breadcrumbs.push({ text: 'ダッシュボード', disabled: false, to: '/driver/home', exact: true })
    } else {
      this.breadcrumbs.push({ text: '受注一覧', disabled: false, to: '/driver/orders/accepts', exact: true })
    }
    this.breadcrumbs.push({ text: '編集', disabled: true, to: '' })
  },
  methods: {}
}
</script>

<style scoped lang="scss">

</style>
